export const CUSTOMER_CURRENCIES = ['USD', 'EUR', 'GBP', 'CAD'] as const;

export type CustomerCurrency = (typeof CUSTOMER_CURRENCIES)[number];

/** Backend PaymentCurrency — same allowlist as customer currencies. */
export type PaymentCurrency = CustomerCurrency;

/** Display symbols for customer currency selector labels (e.g. "USD $"). */
export const CURRENCY_SYMBOLS: Record<CustomerCurrency, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: '$',
};

export function getCurrencyOptionLabel(currency: CustomerCurrency): string {
  return `${currency} ${CURRENCY_SYMBOLS[currency]}`;
}

export const DEFAULT_CURRENCY: CustomerCurrency = 'USD';

/** Cookie storing the customer's selected display/payment currency. */
export const CURRENCY_COOKIE_NAME = 'fe_currency';

export const CURRENCY_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year

/** Outbound API header expected by the backend. */
export const X_CURRENCY_HEADER = 'X-Currency';

/**
 * React Query key roots for responses that vary with X-Currency.
 * Reservation snapshots / historical bookings are intentionally excluded.
 */
export const CURRENCY_SENSITIVE_QUERY_KEY_ROOTS = new Set([
  'tourDetails',
  'tourPrice',
  'tourDetailsPrice',
  'my-tours',
  'preview',
  'combo',
  'tourSearch',
]);

export function isCustomerCurrency(value: unknown): value is CustomerCurrency {
  return typeof value === 'string' && (CUSTOMER_CURRENCIES as readonly string[]).includes(value);
}

/** Returns a supported currency, or USD when missing/invalid. */
export function parseCustomerCurrency(value: string | undefined | null): CustomerCurrency {
  if (value && isCustomerCurrency(value)) {
    return value;
  }
  return DEFAULT_CURRENCY;
}
